export default __webpack_public_path__ + "static/media/Pete.0ed45773.png";